/**
 * tilt.ts — device tilt → normalized steering input (-1..1).
 * Ported from reference/Retro Remix of Car Race/src/lib/tilt.ts.
 *
 * iOS requires a user-gesture permission grant for DeviceOrientationEvent.
 * Call requestTiltPermission() from inside a click handler before startTilt().
 */
type Listener = (norm: number) => void;

let listener: Listener | null = null;
let calibration = 0;
let calibrated = false;

function handle(e: DeviceOrientationEvent) {
  const raw = e.gamma ?? 0;
  if (!calibrated) { calibration = raw; calibrated = true; }
  const adjusted = raw - calibration;
  const norm = Math.max(-1, Math.min(1, adjusted / 30));
  listener?.(norm);
}

export async function requestTiltPermission(): Promise<"granted" | "denied" | "unsupported"> {
  const anyEvt = DeviceOrientationEvent as unknown as { requestPermission?: () => Promise<string> };
  if (typeof anyEvt?.requestPermission === "function") {
    try {
      const res = await anyEvt.requestPermission();
      return res === "granted" ? "granted" : "denied";
    } catch { return "denied"; }
  }
  if (typeof window !== "undefined" && "DeviceOrientationEvent" in window) return "granted";
  return "unsupported";
}

export function startTilt(fn: Listener) {
  listener = fn;
  calibrated = false;
  window.addEventListener("deviceorientation", handle);
}

export function stopTilt() {
  listener = null;
  window.removeEventListener("deviceorientation", handle);
}

export function recalibrate() { calibrated = false; }
